import { render, staticRenderFns } from "./AnnouncementsData.vue?vue&type=template&id=10823b2e&scoped=true&"
import script from "./AnnouncementsData.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsData.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementsData.vue?vue&type=style&index=0&id=10823b2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10823b2e",
  null
  
)

export default component.exports